module.exports = __webpack_public_path__ + "images/emoji/boat.41cc6b89f409bd738ac2.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/boat.png
// module id = cuCd
// module chunks = 2